// @ts-strict-ignore
import React, { Component } from 'react'
import { IonButton } from '@ionic/react'
import { Button as ButtonType } from '../types'

import './styles/button.less'

export default class Button extends Component<ButtonType> {
	buttonRef: HTMLIonButtonElement

	onRef = (ref: HTMLIonButtonElement) => {
		const { ariaLabel } = this.props

		if (ariaLabel) {
			const { shadowRoot } = ref
			const shadowButtons: NodeListOf<HTMLButtonElement | HTMLAnchorElement> | [] = shadowRoot
				? shadowRoot.querySelectorAll('button, a') || []
				: []

			const elementsArr: (HTMLButtonElement | HTMLAnchorElement)[] | [] = [...shadowButtons]

			if (elementsArr) {
				elementsArr.forEach((element: HTMLButtonElement | HTMLAnchorElement) => {
					if (ariaLabel) {
						if (!element.getAttribute('aria-label')) {
							element.setAttribute('aria-label', ariaLabel)
						}
					}
				})
			}
		}
	}

	render() {
		const buttonProps = {
			...this.props,
		}

		if (this.props?.ariaLabel) {
			delete buttonProps.ariaLabel
		}

		return (
			<IonButton
				ref={(ref: HTMLIonButtonElement) => {
					if (!this.buttonRef) {
						setTimeout(() => this.onRef(ref), 1000)
					}
					this.buttonRef = ref

					if (this.props?.buttonRef) this.props.buttonRef(ref)
				}}
				{...buttonProps}
			>
				<div aria-hidden={true}>{this.props.children}</div>
			</IonButton>
		)
	}
}
